module.exports = __webpack_public_path__ + "img/game--madden-22--esrb.fbba2310.png";